<template>
  <div class="shipments-page">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <h2>{{$t('Delivery Orders')}}</h2>
      </div>
    </div>
    <head-component :noActions="true" :statusFilters="$store.state.AppActiveUser.userRole === 'admin' ? statusFilters : customerSupportStatusFilters" :selected="selected" @changeFilter="changeFilter" @filterValue="filterValue = $event" @loadShipments="loadShipments"></head-component>
    <div class="xl:float-left clearfix xl:w-1/2 mt-4 w-full">
      <export-button class="mr-4 float-left whitespace-nowrap"></export-button>
      <download-button class="mr-4 float-left whitespace-nowrap" :selected="selected"></download-button>
      <cancel-shipments-button class="mr-4 float-left whitespace-nowrap" :selected="selected" @selected="selected = $event" @loadShipments="loadShipments"></cancel-shipments-button>
      <print-label-button class="mr-4 float-left whitespace-nowrap" :selected="selected"></print-label-button>
    </div>
    <shipblu-table
     :sst="true"
      orders
      multiple
      v-model="selected"
      :max-items="maximumItems"
      @searchDate="handleSearchDate"
      @search="handleSearch"
      @keyup.enter.native="handleSearch"
      searchDate
      search
      pagination
      :data="shipments"
      :tableLoader="tableLoader"
    >

      <template slot="thead">
        <shipblu-th>{{$t('Created On')}}</shipblu-th>
        <shipblu-th>{{$t('Tracking No.')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant Name')}}</shipblu-th>
        <shipblu-th>{{$t('Customer Name')}}</shipblu-th>
        <shipblu-th>{{$t('Location')}}</shipblu-th>
        <shipblu-th>{{$t('Customer Phone')}}</shipblu-th>
        <shipblu-th>{{$t('Pickup Date')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'admin'">{{$t('RTO Requested')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'admin'">{{$t('Delivery Attempts')}}</shipblu-th>
        <shipblu-th>{{$t('Packages')}}</shipblu-th>
        <shipblu-th>{{$t('Package Size')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th>{{$t('Delivered On')}}</shipblu-th>
        <shipblu-th>{{$t('Actions')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`"
          :to="{ name: `${$store.state.AppActiveUser.userRole}-delivery-orders`, params: { type: 'delivery-orders', orderID: data[indextr].id}}">
          <shipblu-td :data="data[indextr].createdOn">
            {{ common.splitYearOfDate(data[indextr].created) }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].trackingNumber" class="inactive-link">
            <p v-on:click.stop>{{ data[indextr].tracking_number }}</p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].merchant">
            {{ data[indextr].merchant.name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].customerInfo">
            {{ data[indextr].customer.full_name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].location">
            {{ $t(data[indextr].customer.address.zone.name) }} / {{ $t(data[indextr].customer.address.zone.city.name) }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].phone">
            {{ data[indextr].customer.phone }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].pickupDate">
            {{ data[indextr].pickup_date ? new Date(data[indextr].pickup_date).toLocaleDateString('fr-CA') : ''}}
          </shipblu-td>

          <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'admin'" :data="data[indextr].rtoRequested">
            <template v-if="data[indextr].rto_requested">
              <div class="bg-danger h-3 w-3 inline-block rounded-full mr-2"></div>
              <span>RTO</span>
            </template>
          </shipblu-td>

          <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'admin'" :data="data[indextr].deliveryAttempted">
            {{ data[indextr].delivery_attempts}}
          </shipblu-td>

          <shipblu-td :data="data[indextr].packages">
            {{ data[indextr].packages.length }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].packages">
            <p v-for="packageItem in data[indextr].packages" :key="packageItem.index">
              {{packageItem.package.package_size.short_code}}
            </p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`" style="white-space: nowrap;">
            <template v-if="checkTooltip(data[indextr])">
              <vx-tooltip :text="data[indextr].failure_data.map(element => element.question === 'Choose reason for failed delivery'  ? new Date(element.created).toLocaleDateString('fr-CA') + '\n' + element.answer  : '').filter(element => element !== '').join('\n \n')">
                <div class="m-auto flex items-center justify-center font-semibold">
                  <div><span class="status-icon mr-1"></span></div>
                  <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
                </div>
              </vx-tooltip>
            </template>
            <template v-else>
              <div class="m-auto flex items-center justify-center font-semibold">
                <div><span class="status-icon mr-1"></span></div>
                <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
              </div>
            </template>
          </shipblu-td>
          
          <shipblu-td :data="data[indextr].deliveredOn">
            {{ data[indextr].delivered_date && data[indextr].status === 'delivered' ? new Date(data[indextr].delivered_date).toLocaleDateString('fr-CA') : '' }}
          </shipblu-td>

          <shipblu-td >
            <div @click="removeAttribute($event)">
              <vs-dropdown
                vs-trigger-click
                @click="selected = []"
                class="dd-actions cursor-pointer"
              >
                <vs-button
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-more-horizontal"
                  class="mr-2"
                >
                </vs-button>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item
                    @click="viewShipment(data[indextr])"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="EyeIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('View')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                  v-if="data[indextr].status === 'created' || data[indextr].status === 'pickup_requested'"
                    @click="cancelShipment(data[indextr],'cancel this order?' , 'cancelled')"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="XCircleIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Cancel Shipment')}}</span>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="$store.state.AppActiveUser.userRole === 'admin'"
                    @click="blockCustomer(data[indextr])"
                  >
                    <span class="flex items-center">
                      <feather-icon
                        icon="UserXIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Block Customer')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <div class="clearfix flex justify-end">
      <div class="sm:flex block items-center relative float-left mt-6">
        <button class="actions-dropdown relative mr-4">
          <div class="m-auto flex text-base items-center justify-between actions-btn">
            <span class="mr-2" id="pageSpan">{{maximumItems + ' / page'}}</span>
            <feather-icon id="pageIcon" class="w-5 h-5" icon="ChevronDownIcon"></feather-icon>
          </div>
          <div class="dropdown-list hidden-list" id="paginationList">
            <button @click="changePageSize(item)" v-for="item in pageSizes" :key="item.index">
              <span>{{ item }}</span>
            </button>
          </div>
        </button>
        <vs-pagination :total="Math.ceil(totalRows * 1.0 / maximumItems)" v-model="currentPage"></vs-pagination>
      </div>
    </div>
    <block-customer :blockCustomerModal="blockCustomerModal" @blockCustomerModal="blockCustomerModal = $event" :data="customer" @loadShipments="loadShipments"></block-customer>
    <print type="Delivery" :selected="selected"></print>
  </div>
</template>

<script>
import common  from '@/assets/utils/common'
import Print from '../merchant/components/PrintLabels.vue'
import BlockCustomer from '../admin/components/BlockCustomer.vue'
import HeadComponent from '../merchant/components/Header.vue'
import i18nData from '../../i18n/i18nData.js'
import {sendRequest} from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ExportButton from '../headOfFleet/components/ExportButton.vue'
import PrintLabelButton from '../headOfFleet/components/PrintLabelButton.vue'
import CancelShipmentsButton from './components/CancelShipmentsButton.vue'
import DownloadButton from './components/DownloadButton.vue'

export default {
  props: ['userRole'],
  data () {
    return {
      common,
      type: 'Add',
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: [],
      shipments: [],
      statusFilters: [
        {
          name: 'All',
          value: 'all',
          color: ''
        },
        {
          name: 'created',
          value: 'created',
          color: 'bg-dark'
        },
        {
          name: 'pickup requested',
          value: 'pickup_requested',
          color: 'bg-warning'
        },
        {
          name: 'out for pickup',
          value: 'out_for_pickup',
          color: 'bg-warning'
        },
        {
          name: 'picked up',
          value: 'picked_up',
          color: 'bg-primary'
        },
        {
          name: 'in transit',
          value: 'in_transit',
          color: 'bg-primary'
        },
        {
          name: 'en route',
          value: 'en_route',
          color: 'bg-primary'
        },
        {
          name: 'out for delivery',
          value: 'out_for_delivery',
          color: 'bg-warning'
        },
        {
          name: 'RTO Requested',
          value: 'rto_requested',
          color: 'bg-warning'
        },
        {
          name: 'out for return',
          value: 'out_for_return',
          color: 'bg-warning'
        },
        {
          name: 'return to origin',
          value: 'return_to_origin',
          color: 'bg-primary'
        },
        {
          name: 'returned',
          value: 'returned',
          color: 'bg-success'
        },
        {
          name: 'on hold',
          value: 'on_hold',
          color: 'bg-primary'
        },
        {
          name: 'delivery attempted',
          value: 'delivery_attempted',
          color: 'bg-danger'
        },
        {
          name: 'delivered',
          value: 'delivered',
          color: 'bg-success'
        }
      ],
      customerSupportStatusFilters: [
        {
          name: 'All',
          value: 'all',
          color: ''
        },
        {
          name: 'Created',
          value: 'created',
          color: 'bg-dark'
        },
        {
          name: 'Pickup Requested',
          value: 'pickup_requested',
          color: 'bg-warning'
        },
        {
          name: 'Picked Up',
          value: 'picked_up',
          color: 'bg-primary'
        },
        {
          name: 'In Transit',
          value: 'in_transit',
          color: 'bg-primary'
        },
        {
          name: 'Out For Delivery',
          value: 'out_for_delivery',
          color: 'bg-warning'
        },
        {
          name: 'Out For Return',
          value: 'out_for_return',
          color: 'bg-warning'
        },
        {
          name: 'Delivery Attempted',
          value: 'delivery_attempted',
          color: 'bg-danger'
        },
        {
          name: 'Delivered',
          value: 'delivered',
          color: 'bg-success'
        }
      ],
      filters: [],
      searchVal: '',
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      trackingData: {},
      trackingStatus: '',
      searchInProgress: false,
      searchedValue: ' ',
      blockCustomerModal: false,
      customer: {},
      fromDate: '',
      toDate: '',
      criteria: '',
      tableLoader: false,
      pageSizes: [25, 50, 100]
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-delivery-orders-view`,
        query: {
          page: this.currentPage,
          filter: this.filters
        }
      }).catch(() => {})
      this.loadShipments()
    },
    '$route.query.filter' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadShipments()
      }
    },
    'selected' () {
      this.$emit('selected', this.selected)
    }
  },
  methods: {
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.currentPage = 1
      this.loadShipments()
    },
    removeAttribute (event) {
      event.preventDefault()
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    checkTooltip (order) {
      return common.checkTooltip(order)
    },
    handleSearchDate (start, end, criteria) {
      this.fromDate = start ? new Date(start).toISOString().split('T')[0] : ''
      this.toDate = end ? new Date(end).toISOString().split('T')[0] : ''
      this.criteria = criteria
      this.loadShipments()
    },
    handleSearch (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadOrdersSearch)
    },
    loadOrdersSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.loadShipments()
    },
    blockCustomer (data) {
      this.customer = data
      this.blockCustomerModal = true
    },
    loadShipments () {
      this.searchInProgress = true
      this.tableLoader = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}&search=${this.searchVal}&${this.filters.includes('rto_requested') ? 'rto_requested=true' : `status=${this.filters}`}&${this.criteria}_after=${this.fromDate ? this.fromDate : ''}&${this.criteria}_before=${this.toDate ? this.toDate : ''}`
      sendRequest(true, false, this, `api/v1/delivery-orders/${query}`, 'get', null, true,
        (response) => {
          this.shipments = response.data.results
          this.totalRows = response.data.count
          this.searchedValue = this.searchVal
          this.tableLoader = false
        }
      )
      this.searchInProgress = false
    },
    changeFilter () {
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all' || (this.filterValue === 'rto_requested' && this.filters.includes('rto_requested'))) {
        this.filters = []
        if (this.filterValue === 'rto_requested' && !this.filters.includes('rto_requested')) {
          this.filters.push('rto_requested')
        } 
      } else if (this.filters.includes('rto_requested')) {
        this.filters.splice(this.filters.indexOf('rto_requested'), 1)
      }
      this.currentPage = 1
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-delivery-orders-view`,
        query: {
          page: this.currentPage,
          filter: this.filters
        }
      }).catch(() => {})
      this.loadShipments()
    },
    viewShipment (data) {
      this.$router.push({
        name: `${this.$store.state.AppActiveUser.userRole}-delivery-orders`,
        params: {
          type: 'delivery-orders',
          orderID: data.id
        }
      }).catch(() => {})
    },
    cancelShipment (data, sentence, status) {
      this.trackingData = data
      this.trackingStatus = status
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: `${sentence === 'returned' ? i18nData[this.$i18n.locale]['Are you sure you have returned this order to the merchant?'] :  i18nData[this.$i18n.locale]['Are you sure you want to '] + i18nData[this.$i18n.locale][sentence]}`,
        acceptText: i18nData[this.$i18n.locale]['Yes'],
        accept: this.confirmCancelShipment
      })
    },
    confirmCancelShipment () {
      const trackings = [
        {
          order: this.trackingData.id,
          packages: this.trackingData.packages.map(item => item.package.id),
          status: this.trackingStatus
        }
      ]
      sendRequest(false, false, this, 'api/v1/tracking/', 'post', trackings, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.loadShipments()
        }
      )
    }
  },
  components: {
    Print,
    HeadComponent,
    BlockCustomer,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ExportButton,
    PrintLabelButton,
    CancelShipmentsButton,
    DownloadButton
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadShipments()
  }
}
export {common}
</script>

<style scoped>
.vs-dialog {
  max-width: 530px;
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
#order-label-print{
  display: none;
  visibility: hidden;
}
.con-pagination-table{
  display: none;
}
</style>
